<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <div class="formInfo">
          <div
            style="margin-bottom: 10px; font-size: 14px"
            v-if="item.WorkOrderState == 0 || item.WorkOrderState == 3"
          >
            {{ item.LogContent }}
          </div>
          <div v-if="item.WorkOrderState == 0 || item.WorkOrderState == 3">
            <el-divider content-position="left">工单信息</el-divider>
            <EditForm ref="EditForm" :isLog="true"></EditForm>
          </div>
          <!-- <div v-if="item.WorkOrderState == 3">
            <el-divider content-position="left">工单信息</el-divider>
            <EditForm ref="EditForm" :isLog="true"></EditForm>
            <el-divider content-position="left">完成信息</el-divider>
            <Log ref="Log" :isLog="true"></Log>
          </div> -->
        </div>
        <div class="formTime">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in dataList"
              :key="item.Id"
              :timestamp="`${item.Title || ''} ${
                item.LogTime
                  ? moment(item.LogTime).format('YYYY-MM-DD HH:mm')
                  : ''
              }`"
              placement="top"
            >
              <!-- <div
                style="position: absolute; top: -5px; right: 0"
                v-if="item.WorkOrderState == 3 || item.WorkOrderState == 0"
              >
                <el-button type="text">查看</el-button>
              </div> -->
              <div slot="dot" class="dot">
                {{ index + 1 }}
              </div>
              <el-card>
                <span
                  v-if="item.WorkOrderState == 3"
                  style="
                    color: #409eff;
                    border-bottom: 1px solid #409eff;
                    cursor: pointer;
                  "
                  @click="handlePreview(item)"
                  >{{ item.LogContent }}</span
                >
                <span v-else>{{ item.LogContent }}</span>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

      <div class="footer">
        <el-button @click="close" :loading="loading">取消</el-button>
      </div>
    </el-drawer>
    <Log ref="Log" :isLog="true"></Log>
  </div>
</template>
<script>
import moment from 'moment'

import EditForm from './EditForm.vue'
import Log from './Log.vue'
export default {
  data() {
    return {
      dataList: [],
      editorOption: {
        theme: 'snow', // 主题
        placeholder: '',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean', 'link'],
              ['addBtn'],
            ], // 自定义工具栏选项
            handlers: {
              addBtn: (a, b, c, d) => {
                console.log('这里是自定义工具打印出来的')
                console.log(a, b, c, d)
              },
            },
          },
        },
      },
      moment,

      title: '',
      loading: false,

      form: {
        Code: '',
        DeviceItemId: '',
        DeviceItemName: '',
        DeviceItemCode: '',
        WorkOrderType: '',
        Type: '',
        WorkOrderDate: '',
        ExpectDate: '',
        Remarks: '',
        OperatorIds: '',
      },

      rules: {
        Code: [{ required: true, message: '请输入工单编号', trigger: 'blur' }],
        DeviceItemName: [
          { required: true, message: '请选择设备名称', trigger: 'change' },
        ],
        WorkOrderType: [
          { required: true, message: '请选择工单类型', trigger: 'change' },
        ],
        Type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        WorkOrderDate: [
          { required: true, message: '请选择工单日期', trigger: 'change' },
        ],
        // ExpectDate: [
        //   { required: true, message: "请选择预计完成日期", trigger: "change" },
        // ],
        Amount: [
          { required: true, message: '请输入外委维修费用', trigger: 'blur' },
        ],
        OperatorIds: [
          { required: true, message: '请选择人员信息', trigger: 'blur' },
        ],
        // InStorTime: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      drawer: false,
      disabled: false,
      row: {},
      item: {},
      CententList: [],
    }
  },
  props: {},
  components: { EditForm, Log },
  methods: {
    handlePreview(item) {
      this.item = item
      if (this.item.WorkOrderState == 3) {
        this.$nextTick(() => {
          this.$refs.Log.openForm('完成信息', this.item.Content)
        })
      }
      // this.loading = true
      // setTimeout(() => {
      //   this.item = item
      //   this.loading = false
      //   // 滚动到顶部
      //   const formCenter = document.querySelector('.form-center')
      //   if (formCenter) {
      //     formCenter.scrollTop = 0
      //   }
      // }, 500)
    },
    handlePictureCardPreview(file) {
      window.open(file.url)
    },

    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      this.row = row
      this.dataList = []
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderLogDataList',
          {
            Search: [
              {
                Condition: 'WorkOrderId',
                Keyword: id,
              },
            ],
            SortField: 'Sort',
            SortType: 'asc',
          }
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.dataList = resJson.Data || []
            this.CententList =
              this.dataList.filter((item) => {
                return item.WorkOrderState == 3 || item.WorkOrderState == 0
              }) || []
            this.item = this.CententList[this.CententList.length - 1] || {}
            if (
              this.item.WorkOrderState == 0 ||
              this.item.WorkOrderState == 3
            ) {
              this.$nextTick(() => {
                this.$refs.EditForm.openForm(
                  '工单日志',
                  this.item.Content,
                  true
                )
              })
            }
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100% - 50px);
  overflow-y: auto;
  padding: 10px 20px;
  display: flex;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
::v-deep .ql-editor {
  height: 600px;
}
.image-item {
  width: 200px;
  height: 200px;
  border: 1px solid #ccc;
  margin-right: 10px;
  margin-bottom: 10px;
}
.formInfo {
  width: calc(100% - 350px);
}
.formTime {
  width: 300px;
  margin-left: 40px;
}
::v-deep .el-drawer__body {
  overflow: hidden;
}

.dot {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #909399;
  background: #ffffff;
  color: #909399;
  font-size: 12px;
  border-radius: 50%;
}
::v-deep .el-timeline-item__tail {
  left: 9px;
}
</style>
